<script>
	import { onMount } from "svelte";

	import PageSection from "../../components/PageSection.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";
	import { registerSubmit } from "../../tealium";

	export let pageIndex = null;
	export let pageTitle = null;

	$pageNumber = pageIndex;
	document.title = pageTitle;

	window.onbeforeunload = null;

	onMount(() => registerSubmit($model.Contact.emailAddress, $model.Contact.phoneNumber, $model.RegistrationNumber));
</script>

<PageSection>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<h1>Thank you</h1>

			<p>
				Thank you for completing your registration form for the {projectSettings.classActionName}.
			</p>

			<p>
				Your reference number is: <strong>{$model.RegistrationNumber}</strong>
			</p>

			<p>
				If you have any questions, please contact Shine Lawyers on
				<ClassActionPhoneNumber></ClassActionPhoneNumber>, or at <ClassActionEmailAddress
				></ClassActionEmailAddress> and quote the registration number above.
			</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}
</style>
